import React from 'react';
import PropTypes from 'prop-types';
import SparklesOutline from '@/shared/assets/icons/SparklesOutline.svg?react';

const AiActionLink = ({
    label,
    onClick,
    disabled = false,
    style = {},
    iconStyle = {},
    className = '',
}) => {
    return (
        <button
            type="button"
            className={className}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                color: disabled ? '#9CA3AF' : '#1777ff',
                cursor: disabled ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: 400,
                background: 'transparent',
                border: 'none',
                padding: 0,
                userSelect: 'none',
                ...style,
            }}
        >
            <SparklesOutline style={{ fontSize: '16px', ...iconStyle }} />
            <span>{label}</span>
        </button>
    );
};

AiActionLink.propTypes = {
    label: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    iconStyle: PropTypes.object,
    className: PropTypes.string,
};

export default AiActionLink;

